import { Cascader, CascaderOption } from "antd-mobile";
import { useEffect, useMemo, useState } from "react";
import { getRegionByPid } from "../apis/common";

/**
 * 省市区选择器
 * mode: text用于兼容纯文本值value
 */
export function LocationCascader({
    value,
    visible,
    onClose,
    onConfirm
}: {
    value?: string[],
    visible?: boolean,
    onClose?: (() => void),
    onConfirm?: ((value: string[], extend: any) => void),
}) {
    const [valueToOptions, setValueToOptions] = useState(
        {} as Record<string, CascaderOption[] | null>
    )
    const options = useMemo<CascaderOption[]>(() => {
        function generate(v: string): CascaderOption[] | undefined {
            const options = valueToOptions[v]
            if (options === null) {
                return undefined
            }
            if (options === undefined) {
                return Cascader.optionSkeleton
            }
            return options.map(option => ({
                ...option,
                children: generate(option.value),
            }))
        }
        return generate('') ?? []
    }, [valueToOptions])

    async function fetchOptionsForValue(v: string, level: number) {
        if (v in valueToOptions) return
        if (level >= 4) {
            setValueToOptions(prev => ({
                ...prev,
                [v]: null,
            }))
            return
        }
        const data = await getRegionByPid({ pid: v ? Number(v) : undefined });
        const options =
            data.data.items.map(entry => ({
                value: String(entry.id),
                label: entry.name,
            }))
        setValueToOptions(prev => ({
            ...prev,
            [v]: options,
        }))
    }

    // 初始化
    useEffect(() => {
        fetchOptionsForValue('', 0)
    }, [])

    return (
        <Cascader
            value={value}
            options={options}
            onSelect={value => {
                value.forEach((v, index) => {
                    fetchOptionsForValue(v, index + 1)
                })
            }}
            onConfirm={(value, extend) => onConfirm ? onConfirm(value, extend) : null}
            visible={visible}
            onClose={onClose}
        >
            {items => {
                if (items.every(item => item === null)) {
                    return '未选择'
                } else {
                    return items.map(item => item?.label ?? '未选择').join('-')
                }
            }}
        </Cascader>
    );
}